export const ApiConstants = {
  RequestCancelMessage: 'Cancelled',
};
